import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { getTestIds } from '../../../../../utils/TestIds';
import { Avatar } from '../../../../Avatar';
import { Column, Row } from '../../../../Layout';
import { Typography } from '../../../../Typography';
import styles from '../cells.module.scss';
import { asIdentity } from './IdentityCell.utils';
export function IdentityCell(param) {
    let { value, emptyText, moreLabel, nameWeight, testId } = param;
    var _identity_count, _ref;
    const testIds = getTestIds(testId);
    const identity = asIdentity(value);
    if (identity == null) {
        return /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            skin: "disabled",
            testId: testId,
            children: emptyText
        });
    }
    const remaining = ((_identity_count = identity.count) !== null && _identity_count !== void 0 ? _identity_count : 0) - 1;
    const suffix = remaining > 0 ? (_ref = moreLabel === null || moreLabel === void 0 ? void 0 : moreLabel(remaining)) !== null && _ref !== void 0 ? _ref : " +".concat(remaining) : '';
    return /*#__PURE__*/ _jsxs(Row, {
        alignItems: "center",
        gap: 8,
        className: styles.identity,
        children: [
            identity.avatarUrl != null && /*#__PURE__*/ _jsx(Avatar, {
                src: identity.avatarUrl,
                className: styles.avatar,
                "data-testid": testIds.avatar()
            }),
            identity.avatarUrl == null && identity.initials != null && /*#__PURE__*/ _jsx(Avatar, {
                className: "".concat(styles.avatar, " ").concat(styles.initialsAvatar),
                "data-testid": testIds.avatar(),
                children: identity.initials
            }),
            /*#__PURE__*/ _jsxs(Column, {
                gap: 0,
                className: styles.stacked,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        ellipsis: true,
                        weight: nameWeight,
                        testId: testId,
                        children: "".concat(identity.name).concat(suffix)
                    }),
                    identity.email != null && /*#__PURE__*/ _jsx(Typography, {
                        ellipsis: true,
                        variant: "paragraph2",
                        skin: "secondary",
                        testId: testIds.email(),
                        children: identity.email
                    })
                ]
            })
        ]
    });
}
